module.exports = __webpack_public_path__ + "img/car2.c9ee06d6.png";